import FocusableButton from 'components/common/FocusableButton';
import useNavigation from 'hooks/app/useNavigation';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import logo from 'images/logo.png';

export default function LogoButton(props) {
  const {
    onReset,
  } = useNavigation('App');

  const patientList = Recoil.useRecoilValue(AppStore.assets.patient_list);
  const setPatientNo = Recoil.useSetRecoilState(AppStore.assets.patient_no);
  const resetStart = Recoil.useResetRecoilState(AppStore.assets.period_start);
  const resetEnd = Recoil.useResetRecoilState(AppStore.assets.period_end);

  const onStateReset = React.useCallback(() => {
    setPatientNo(() => patientList[0].patient_no || null);
    resetStart();
    resetEnd();
  }, [patientList, resetEnd, resetStart, setPatientNo]);

  return (
    <FocusableButton
      {...ex('LogoButton', props)}
      {...{ onClick: onReset(['Overview'], onStateReset) }}
    >
      <div style={{ width: 200, height: 150 }}>
        <img src={logo} alt={'logo'} />
      </div>
    </FocusableButton>
  );
}
